<template>
    <outboxCon>
        <div class="core-capablity">
            <app-title main='我们的核心能力' sub='赋能机构，把优质教育资源带进千家万户'></app-title>
            <div class="core-cap-content">
                <div class="core-cap-content-item">
                    <img class="home-core-1" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-core-1.png">
                </div>
                <div class="core-cap-content-item">
                    <div class="teach-box">
                        <img class="home-core-2" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-core-2.png">
                        <p class="teach-box-title">教研积累</p>
                        <p class="des">好未来<span class="strong">18年</span>教研资源与数据沉淀</p>
                        <p class="des"><span class="strong">百万</span>真题库与教学视频在线支持</p>
                        <p class="des"><span class="strong">千人</span>教研团队助力内容快速升级</p>
                    </div>
                </div>
                <div class="core-cap-content-item">
                    <div class="teach-box">
                        <img class="home-core-3" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-core-3.png">
                        <p class="teach-box-title">科技投入</p>
                        <p class="des">与 <span class="strong">6所</span> 全球知名大学等建立联合实验室</p>
                        <p class="des">投入超 <span class="strong">12亿元</span>/年 用于科技研发</p>
                        <p class="des">组建超 <span class="strong">5000人</span> 技术研发团队</p>
                    </div>
                </div>
                <div class="core-cap-content-item">
                    <div class="tech-box">
                        <div class="tech-box-item" :class="`tech-item-${index + 1}`" v-for="(item, index) in techList" :key="'tech' + index">
                            <img class="icon-tech" :src="`https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-core-4-${index + 1}.png`">
                            <p class="strong">{{item.strong}}</p>
                            <p class="normal">{{item.normal}}</p>
                        </div>
                    </div>
                </div>
                <div class="core-cap-content-item">
                    <div class="techer-box">
                        <div class="teacher-box-item bg1">
                            <img class="icon-teacher" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/chenggang.png">
                            <p class="teacherame">程港-北京大学</p>
                        </div>
                        <div style="margin-left:-2px;" class="teacher-box-item">
                            <img class="icon-teacher" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/duanhongyu.png">
                            <p class="teacherame">段红宇-北京大学</p>
                        </div>
                        <div class="teacher-box-item bg1">
                            <img class="icon-teacher" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/wuhaibo.png">
                            <p class="teacherame">吴海波-清华大学</p>
                        </div>
                        <div style="margin-left:-2px;" class="teacher-box-item">
                            <img class="icon-teacher" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/xuhaowei.png">
                            <p class="teacherame">许豪伟-北京大学</p>
                        </div>
                    </div>
                </div>
                <div class="core-cap-content-item">
                    <div class="teach-box">
                        <img class="home-core-6" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/home-core-6.png">
                        <p class="teach-box-title">优质教师</p>
                        <p class="des">魔法校专业讲师</p>
                        <p class="des"><span class="strong">6轮</span>选拔，平均授课时长超<span class="strong">5000小时</span></p>
                        <p class="des">单次讲课<span class="strong">10小时</span>以上备课磨课，<span class="strong">5次</span>以上试讲</p>
                    </div>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
export default {
  data () {
    return {
      techList: [
        {
          strong: '6所',
          normal: '联合实验室'
        },
        {
          strong: '12亿元',
          normal: '资金投入'
        },
        {
          strong: '5000人',
          normal: '研发团队'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
    .core-capablity{
        width: $main-width;
        margin: 0 auto;
        padding: 60px 86px 95px;
        .core-cap-content{
            margin-top: 88px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            .core-cap-content-item{
                width: 554px;
                height: 554px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .home-core-1{
                    width: 554px;
                    height: 554px;
                }
                .teach-box{
                    text-align: left;
                    margin-left: 116px;
                    .home-core-2{
                        width: 96px;
                        height: 106px;
                    }
                    .home-core-3{
                        width: 91px;
                        height: 92px;
                    }
                    .home-core-6{
                        width: 88px;
                        height: 90px;
                    }
                    .teach-box-title{
                        font-family: PingFangSC-Semibold;
                        font-size: 40px;
                        line-height: 36px;
                        margin-top: 31px;
                        margin-bottom: 24px;
                    }
                    .des{
                        font-family: PingFangSC-Regular;
                        font-size: 22px;
                        line-height: 36px;
                        .strong{
                            color: #FB594A;
                            font-family: PingFangSC-Semibold;
                        }
                    }
                }
                .tech-box{
                    width: 100%;
                    .tech-box-item{
                        text-align: left;
                        padding-left: 58px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        height: 184.6px;
                        width: 100%;
                        .icon-tech{
                            margin-right: 50px;
                            width: 145px;
                            height: 145px;
                        }
                        .strong{
                            font-family: PingFangSC-Medium;
                            font-size: 36px;
                            line-height: 35px;
                            color: #FB594A;
                        }
                        .normal{
                            font-family: PingFangSC-Regular;
                            font-size: 24px;
                            line-height: 35px;
                            color: #4D4A52;
                        }
                        &.tech-item-1{
                            background: #f5f7fa;
                        }
                        &.tech-item-2{
                            background: #eff1f7;
                        }
                        &.tech-item-3{
                            background: #eaedf6;
                        }
                    }
                }
                .techer-box{
                    width: 554px;
                    display: flex;
                    justify-content: flex-start;
                    align-content: flex-start;
                    flex-wrap: wrap;
                    .teacher-box-item{
                        width: 50%;
                        height: 277px;
                        background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/teacher-bg2.png') no-repeat 100% 100%;
                        position: relative;
                        overflow: hidden;
                        .icon-teacher{
                            transition:transform .5s;
                            width: 250px;
                            height: 250px;
                            margin-top: 27px;
                        }
                        .teacherame{
                            position: absolute;
                            left: 0px;
                            bottom: 0px;
                            width: 100%;
                            height: 64px;
                            line-height: 64px;
                            padding-left: 24px;
                            text-align: left;
                            font-size:18px;
                            font-family:PingFangSC-Regular;
                            color:#A0A0A1;
                            background: rgba(14,19,28,0.5);
                            z-index: 1;
                        }
                        &.bg1{
                            background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/teacher-bg1.png') no-repeat 100% 100%;
                        }
                        &:hover{
                            .icon-teacher{
                                transform: scale(1.2);
                            }
                            .teacherame{
                                color: #ffffff;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
